import context, { IAppUserContext } from '@truckdown/components-systems';
import { IInitializer, IUserContext } from "@truckdown/systems";
import developerSideNav from './DeveloperSideNav/DeveloperSideNav.vue';

class DeveloperComponentInitializer implements IInitializer {
    name: string = 'DeveloperComponentInitializer';
    order: number = 0;

    async initialize(context: IUserContext): Promise<void> {
        let app = (context as IAppUserContext).app;
        app.component('DeveloperSideNav', developerSideNav);
    }
}

context.registerService({
    name: 'IInitializer',
    activator: async () => {
        return new DeveloperComponentInitializer();
    }
});